import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bootstrap"
export default class extends Controller {
  connect() {
    // Initialize all tooltips on the page
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    // Initialize all popovers on the page
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

    // Store the instances for cleanup
    this.tooltips = tooltipList
    this.popovers = popoverList
  }

  disconnect() {
    // Clean up tooltip instances when the controller is disconnected
    if (this.tooltips) {
      this.tooltips.forEach(tooltip => tooltip.dispose())
    }

    // Clean up popover instances when the controller is disconnected
    if (this.popovers) {
      this.popovers.forEach(popover => popover.dispose())
    }
  }
}